import {
  GET_CUSTOMER_LIST,
  GET_CUSTOMER_LIST_FAILURE,
  GET_CUSTOMER_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LIST:
      return { ...state, loading: true };
    case GET_CUSTOMER_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CUSTOMER_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCustomerReducer;
